import { Card } from '@/components/ui/card';

export function KpiCard({ label, value, hint, trend, icon: Icon, testId }) {
  return (
    <Card className="kpi-card border" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div className="text-xs uppercase tracking-wide text-muted-foreground font-medium">{label}</div>
        {Icon && (
          <div className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary text-muted-foreground">
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className="tabular text-3xl font-semibold tracking-tight">{value}</div>
        {trend && (
          <span className={`text-xs font-medium ${trend.positive ? 'text-emerald-600' : 'text-rose-600'}`}>
            {trend.label}
          </span>
        )}
      </div>
      {hint && <div className="mt-1 text-xs text-muted-foreground">{hint}</div>}
    </Card>
  );
}
